import React from 'react';

import PhotosEdit from './PhotosEdit';
import EditModalControl from '../../../common/edit/EditModalControl';

interface Props {
  type: 'button' | 'link';
  show?: boolean;
  buttonDataTestId?: string;
  linkDataTestId?: string;
  onSuccess: () => void;
}

const PhotosEditModal = ({ type, show, buttonDataTestId, linkDataTestId, onSuccess }: Props) => (
  <EditModalControl
    type={type}
    title={'Edit Photos'}
    show={show}
    expanded
    buttonDataTestId={buttonDataTestId}
    linkDataTestId={linkDataTestId}
    onSuccess={onSuccess}
  >
    <PhotosEdit />
  </EditModalControl>
);

export default PhotosEditModal;
